var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('gc-alert',{staticClass:"gc__browser-alert",attrs:{"type":"warning","closeable":true,"show":!_vm.supported}},[_vm._v(" Your browser is outdated. For a better experience , please update your browser to its latest version. ")])}
var staticRenderFns = []

export { render, staticRenderFns }